export default __webpack_public_path__ + "static/media/Dhananithi Jewellers.6dfdb220.png";